import React from 'react';

import { Form } from 'antd';
import { Input } from 'rsuite';

import Config from '../../config/Config';
import Cache from '../../frame/Cache';
import WidgetAjax from '../../widget/WidgetAjax';

import WidgetSelect from '../../widget/WidgetSelect';
import WidgetReport from '../../widget/WidgetReport';
import WidgetComponent from '../../widget/WidgetComponent';
import WidgetTreePicker from '../../widget/WidgetTreePicker';
import WidgetDatePicker from '../../widget/WidgetDatePicker';
import titleLeft from "../../img/home/TitleLeft.svg"

import 'antd/dist/antd.css';

class UserLog extends WidgetComponent
{
    constructor( props )
    {
        super(props);

        let path = Config.getBasePath();

        if( path.endsWith('/')===false )
        {
            path = path + '/';
        }

        let userInfo = sessionStorage.getItem("_user_info_");

        if( userInfo!==undefined && userInfo!==null )
        {
            userInfo = JSON.parse(userInfo);
        }

        this.state = {
            userInfo:userInfo,
            path : path,
            keyWord : undefined,
            typeValue: 1,
            group : undefined, 
            state : undefined, 
            parentDepartmentId : undefined, 
            departmentId : undefined,
            startDate:undefined,
            endDate : undefined,
            showType : 1,
            dateOptions : {
                name : "",
                isLeftTitle : false,
                dateType : "date",
                dateTypes : [{title:'日', value:'date'}],
                datePickerType:'range', 
            },
            report : {
                'schemas':[
                    {'name':'T500001', 'dimensions':[]}
                ],
                'type':'report'
            },
            report2 : {
                'schemas':[
                    {'name':'T500002', 'dimensions':[]}
                ],
                'type':'report'
            },
            report3 : {
                'schemas':[
                    {'name':'T500003', 'dimensions':[]}
                ],
                'type':'report'
            },
            report4 : {
                'schemas':[
                    {'name':'T500004', 'dimensions':[]}
                ],
                'type':'report'
            },
            userStatusData: [
                {label:'用户无效', value:'0'},
                {label:'用户生效', value:'1'},
                {label:'用户暂关', value:'2'}
            ],
            selectoptions:{
                cleanable : true,
            },
            groupData: [],
            typeData: [
                {
                    value:1,
                    label:'姓名'
                },
                {
                    value:2,
                    label:'手机号码'
                }
            ],
            parentDepartmentData:[],
            departmentTreeoptions : {
                title:"",
                type : 'select'
            },
            departmentData:[]
        };

        
        this.back = this.back.bind(this);

        this.clear=this.clear.bind(this);
        this.queryData=this.queryData.bind(this);
        this.notify = this.notify.bind(this);

        this.paramsChange=this.paramsChange.bind(this);
        this.onDateSelect=this.onDateSelect.bind(this);
        this.departmentOnSelect=this.departmentOnSelect.bind(this);
        this.parentDepartmentOnSelect=this.parentDepartmentOnSelect.bind(this);
        
        this.groupSearch = this.groupSearch.bind(this);
        this.onGroupSearch = this.onGroupSearch.bind(this);

        this.loadDepartmentInfo = this.loadDepartmentInfo.bind(this);
        this.onLoadDepartmentInfo = this.onLoadDepartmentInfo.bind(this);
        this.buildDepartmentData = this.buildDepartmentData.bind(this);

        this.bindConsole(path);
    }

    componentDidMount()
    {
        this.loadDepartmentInfo();
        this.groupSearch();
    }

    clear()
    {
        window.location.reload();
    }

    queryData()
    {   
        let filters = {};

        const { keyWord, typeValue, group, state, parentDepartmentId, departmentId, startDate, endDate} = this.state;

        if( keyWord!==undefined && keyWord!=="" )
        {
            if( typeValue===1)
            {
                filters["realname"] = "${realname} has '"+keyWord+"'";
            }  
        }

        if( group!==undefined && group!==""&& group!==null )
        {
            filters["groupId"] = "${groupId} = '"+group+"'";
        }
        else
        {
            filters["groupId"] = undefined;
        }

        if( state!==undefined && state!=="" && state!==null )
        {
            filters["state"] = "${state} = '"+state+"'";
        }
        else
        {
            filters["state"] = undefined;
        }

        if( departmentId!==undefined && departmentId!==""&& departmentId!==null )
        {
            filters["departmentId"] = "${departmentId} = '"+departmentId+"'";
        }
        else
        {
            filters["departmentId"] = undefined;
        }

        if( parentDepartmentId!==undefined && parentDepartmentId!==""&& parentDepartmentId!==null )
        {
            filters["parentDepartmentId"] = "${parentDepartmentId} = '"+parentDepartmentId+"'";
        }

        else
        {
            filters["parentDepartmentId"] = undefined;
        }

        if( startDate!==undefined && startDate!=="" && startDate!==null )
        {
            filters["dateStart"] = startDate;
        }
        else
        {
            filters["dateStart"] = undefined;
        }

        if( endDate!==undefined && endDate!=="" && endDate!==null )
        {
            filters["dateEnd"] = endDate;
        }
        else
        {
            filters["dateEnd"] = undefined;
        }

        this.sendEvent("set.report.filter", {schemaName:"T500001", filters:filters});
        this.setState({showType:1});
    }

    /**
     * 角色搜索函数
     */
    groupSearch()
    {
        const { path,userInfo } = this.state;
        let params = {
            page : 1,
            records : 99999
        };

        if(userInfo.realmId !== undefined && userInfo.realmId !== null && userInfo.realmId !== ""){
            params['realm_id'] = userInfo.realmId
        };


        WidgetAjax.ajax({url:path + 'role/search', params:params, callback:this.onGroupSearch});
    }

    /**
     * 角色搜索回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onGroupSearch( result, params )
    {
        if( result.status===0 )
        {
            let groupData = [];

            for(let item of result.results )
            {
                item["label"] = item.name;
                item["value"] = item.id;

                groupData.push(item);
            }

            this.setState({groupData:groupData});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    loadDepartmentInfo()
    {
        const { path,userInfo } = this.state;

        let params = {
            records : 9999
        }

        if(userInfo.realmId !== undefined && userInfo.realmId !== null && userInfo.realmId !== ""){
            params['realm_id'] = userInfo.realmId
        };

        WidgetAjax.ajax({url:path + 'group/search', params:params, callback:this.onLoadDepartmentInfo});
    }

    onLoadDepartmentInfo(result, params )
    {
        if( result.status===0 )
        {
            let departmentData = this.buildDepartmentData(result.results, -1);

            this.setState({parentDepartmentData:departmentData, departmentData:departmentData});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }
    
    buildDepartmentData( data, parent)
    {
        let items = [];

        for( let i=0; i<data.length; i++ )
        {
            let node = {};
            
            node.role = parent;
            node.label = data[i].name;
            node.id = data[i].id;
            node.value = data[i].id;

            if( data[i].subdepartments !== undefined )
            {
                node.children = this.buildDepartmentData(data[i].subdepartments, data[i].id);
            }
            
            items.push(node);
        }

        return items;
    }

    /**
     * 上级部门选择
     * @param {*} values 
     */
    parentDepartmentOnSelect( values )
    {
        
        if(values.length === 0)
        {
            this.state["parentDepartmentId"] = undefined;
            return null;
        }

        if( values!==undefined && values.length ===1 )
        {
            this.state["parentDepartmentId"] = values[0];
        }
    }

    /**
     * 所属部门选择
     * @param {*} values 
     */
    departmentOnSelect( values )
    {
        if(values.length === 0)
        {
            this.state["departmentId"] = undefined;
            return null;
        }

        if( values !== undefined && values.length === 1 )
        {
            this.state["departmentId"] = values[0];
        }
    }

    paramsChange(value,type)
    {
        switch( type )
        {
            case 'type':
            {
                this.state["typeValue"] = value;
                break;
            }
            case 'state':
            {
                this.state["state"] = value;
                break;
            }
            case 'keyWord':
            {
                this.state["keyWord"] = value;
                break;
            }
            case 'group':
            {
                this.state["group"] = value;
                break;
            }
            default:
                break;
        }
    }

    onDateSelect( value )
    {
        if( value!==undefined )
        {
            this.setState({startDate:value.start, endDate:value.end });
        }
    }

    notify( type, data, value, event )
    {
        // data
        data = JSON.parse(data);

        // filters
        let filters = {};

        const { startDate, endDate} = this.state;

        filters["UID"] = data.UID;

        if( startDate!==undefined && startDate!=="" )
        {
            filters["dateStart"] = startDate;
        }

        if( endDate!==undefined && endDate!=="" )
        {
            filters["dateEnd"] = endDate;
        } 

        // event
        switch( type )
        {
            case "onUserSearchLog":
            {
                this.sendEvent("set.report.filter", {schemaName:"T500002", filters:filters});
				this.setState({showType:2});
                break;
            }
            case "onUserNavigationLog":
            {
                this.sendEvent("set.report.filter", {schemaName:"T500003", filters:filters});
				this.setState({showType:3});
                break;
            }
            case "onUserDownloadLog":
            {
                this.sendEvent("set.report.filter", {schemaName:"T500004", filters:filters});
				this.setState({showType:4});
                break;
            }
            default : 
                break;
        }
       
    }

    back()
    {
        this.setState({showType:1});
    }

    render()
    {
        const { userStatusData, state, selectoptions, typeData, typeValue, keyWord, groupData, group,dateOptions, startDate, endDate,
            departmentTreeoptions, parentDepartmentData, departmentData, department, departmentId, parentDepartmentId, report, report2, report3, report4, showType} = this.state;

        return (
            <div className="page" style={{height:"100%"}}>
                <div className="page-weidu" style={{padding:"0"}}>
                    <div className="page-title" style={{textAlign:"left"}}>
                        <div className="page-title-img"><img style={{marginRight:"0px"}} src={titleLeft}/></div>
                        <span className="page-title-font">数据统计</span>
                    </div>
                </div>
                
                <div className="page-content page-height" style={{height:'auto', paddingBottom: 0}} >
                    <div className="content-canvas content-top-frame-height height-100 content-height" style={{borderRadius:"1px",boxShadow:"none"}}>
                        <div className="selectTime">
                            <div className="selectLog">
                                <div >
                                    <Form.Item label="用户状态" className="aaa">
                                        <WidgetSelect options={selectoptions} data={userStatusData} onSelect={(value)=>this.paramsChange(value,'state')} defaultValue={state} ></WidgetSelect>
                                    </Form.Item>
                                </div>
                                <div >
                                    <Form.Item label="角色" >
                                        <WidgetSelect options={selectoptions} data={groupData} onSelect={(value)=>this.paramsChange(value,'group')} defaultValue={group} ></WidgetSelect>
                                    </Form.Item>
                                </div>
                            </div>

                            <div className="selectLog flex-left"> 
                                <div className="datepicker">
                                    <Form.Item label="添加时间">
                                    <WidgetDatePicker onSelect={(value)=>{this.onDateSelect(value)}} 
                                        defaultValue={{dateStart:startDate, dateEnd:endDate, dateType:"date"}}
                                        options={dateOptions}/>
                                    </Form.Item>
                                </div>
                                <div >
                                    <Form.Item label="所属行">
                                        <WidgetTreePicker options={departmentTreeoptions} data={departmentData} defaultValues={[departmentId]}
                                            onSelect={this.departmentOnSelect} pageWidth={"300px"}></WidgetTreePicker>
                                    </Form.Item>
                                </div> 
                            </div>
                            <div className="selectLog">
                                <div className="superior">
                                    <Form.Item label="姓名">
                                    <div style={{width: '208px', margin:'5px 10px', float: 'left', borderRadius:"0px"}} >
                                        <Input onChange={(value) => {this.paramsChange(value, 'keyWord')}} value={keyWord}></Input>
                                    </div>
                                    </Form.Item>
                                </div>
                                <div className="superior">
                                <Form.Item label="上级行">
                                    <WidgetTreePicker options={departmentTreeoptions} data={parentDepartmentData} defaultValues={[parentDepartmentId]}
                                        onSelect={this.parentDepartmentOnSelect} pageWidth={"300px"}></WidgetTreePicker>
                                </Form.Item>
                                </div>
                            </div>
                        </div> 

                        <div className="selectState" style={{border:"none"}}>
                            <button className="query click" onClick={this.queryData} >确定</button>
                            <button className="clear click" onClick={this.clear}>取消</button>
                        </div>
                    </div>
                </div> 

                <div className="page-content page-overflow page-table body-height" style={showType===1 ? {display:'block'} : {display:'none'}}>
                    <div className="content-canvas content-top-frame-height height-100" style={{borderRadius:"0",boxShadow:"none"}}>
                        <div className="content-title Addroles content-title-addroles">
                            <div className="img search-result">
                                {/* <img src={require("./img/ml-ztzt.png")} alt=""></img> */}
                                <img style={{marginRight:"9px"}} src={titleLeft}/>
                                <span style={{fontWeight:"700",fontSize:"18px"}}>查询结果列表</span>
                            </div>
                        </div>
                    
                        <div className="content-chart-height content-table" style={{minHeight:"470px",marginTop:"0"}}>
                            <WidgetReport parent={this} onRef={this.onRef} notifyEvent={this.notifyEvent} notify={this.notify} report={report} pageFlag={true}></WidgetReport>
                        </div>
                    </div>
                </div> 

                <div className="page-content page-overflow page-table body-height" style={showType!==1 ? {display:'block'} : {display:'none'}}>
                    <div className="content-canvas content-top-frame-height height-100">
                        <div className="content-title Addroles">
                            <div className="img search-result" onClick={this.back} style={{paddingLeft:"20px"}}>
                                {/* <span className="backlist click" style={{marginLeft:"24px"}}>返回列表</span> */}
                                <div className='go_back'><img src={require('./img/icon/goback.svg')} /></div>
                            </div>
                        </div>
                    
                        

                        <div className="content-chart-height content-table" style={showType===2 ? {display:'block', height:'calc(100% - 64px)',marginTop:"0"} : {display:'none'}}>
                            <WidgetReport parent={this} onRef={this.onRef} notifyEvent={this.notifyEvent} notify={this.notify} report={report2} pageFlag={true}></WidgetReport>
                        </div>
                        <div className="content-chart-height content-table" style={showType===3 ? {display:'block', height:'calc(100% - 64px)',marginTop:"0"} : {display:'none'}}>
                            <WidgetReport parent={this} onRef={this.onRef} notifyEvent={this.notifyEvent} notify={this.notify} report={report3} pageFlag={true}></WidgetReport>
                        </div>
                        <div className="content-chart-height content-table" style={showType===4 ? {display:'block', height:'calc(100% - 64px)',marginTop:"0"} : {display:'none'}}>
                            <WidgetReport parent={this} onRef={this.onRef} notifyEvent={this.notifyEvent} notify={this.notify} report={report4} pageFlag={true}></WidgetReport>
                        </div>
                    </div>
                </div> 
            </div>
        );
    }
}

export default UserLog


